/**
 * Application constants and configuration
 */

// API Configuration settings
export const API_CONFIG = {
  TIMEOUT: 15000, // 15 seconds
  RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
  CACHE_TIMEOUT: 5 * 60 * 1000, // 5 minutes
};

// Cache keys for different entity types
export const CACHE_KEYS = {
  THEMES: 'themes',
  USERS: 'users',
  QUESTIONS: 'questions',
  RESPONSES: 'responses',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  REPRESENTATIVE: 'representative',
};

// Entity Types
export const ENTITY_TYPES = {
  THEMES: 'themes',
  USERS: 'users',
  QUESTIONS: 'questions',
  RESPONSES: 'responses',
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur de connexion. Vérifiez votre réseau.',
  AUTH_ERROR: 'Session expirée. Veuillez vous reconnecter.',
  NOT_FOUND: 'Ressource non trouvée.',
  CONFLICT: 'Conflit de données. Veuillez réessayer.',
  TIMEOUT: 'Délai d\'attente dépassé.',
  UNKNOWN_ERROR: 'Une erreur inattendue s\'est produite.',
  NO_TOKEN: 'No authentication token available',
  INVALID_RESPONSE: 'Réponse d\'authentification invalide.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  THEME_CREATED: 'Thème créé.',
  THEME_UPDATED: 'Thème mis à jour.',
  THEME_DELETED: 'Thème déplacé dans la corbeille.',
  THEME_RESTORED: 'Thème restauré.',
  THEME_HARD_DELETED: 'Thème supprimé définitivement.',
  USER_CREATED: 'Utilisateur créé.',
  USER_UPDATED: 'Utilisateur mis à jour.',
  USER_DELETED: 'Utilisateur déplacé dans la corbeille.',
  USER_RESTORED: 'Utilisateur restauré.',
  USER_HARD_DELETED: 'Utilisateur supprimé définitivement.',
  LOGIN_SUCCESS: 'Connexion réussie.',
  LOGOUT_SUCCESS: 'Déconnecté.',
};

// Default Values
export const DEFAULTS = {
  LANGUAGE: 'fr',
  PAGE_SIZE: 20,
  DEBOUNCE_DELAY: 300,
  ANIMATION_DURATION: 200,
};

// Validation Rules
export const VALIDATION = {
  MIN_NAME_LENGTH: 1,
  MAX_NAME_LENGTH: 255,
  MIN_PASSWORD_LENGTH: 6,
  MAX_PASSWORD_LENGTH: 128,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};
